/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ThemeInputs */

const en_us2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme`)
};

const pt_br2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const es_419_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const pt_pt2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const fr_fr2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème`)
};

const de_de2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const it_it2_profile_theme = /** @type {(inputs: Profile_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

/**
* | output |
* | --- |
* | "Theme" |
*
* @param {Profile_ThemeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_theme = /** @type {((inputs?: Profile_ThemeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ThemeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_theme(inputs)
	if (locale === "es-419") return es_419_profile_theme(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_theme(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_theme(inputs)
	if (locale === "de-DE") return de_de2_profile_theme(inputs)
	if (locale === "it-IT") return it_it2_profile_theme(inputs)
	return en_us2_profile_theme(inputs)
});
export { profile_theme as "profile.theme" }